import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from './token.service';

export const adminGuard: CanActivateFn = () => {
  const tokenService = inject(TokenService);
  const router = inject(Router);
  const user = tokenService.currentUser();

  if (user?.role === 'Admin') {
    return true;
  }

  return router.createUrlTree(['/panel/dashboard']);
};
